<template>
    <v-navigation-drawer
        v-model="drawer"          
        width="600"
        app
        temporary
        right
        class="wost-drawer"
    >
        <div class="form-head">
            {{ titleForm }}
        </div>
        <div class="wrapper-form-crud overflow-y-auto">               
            <v-form>
                <v-card class="padding-bootom-0">
                    <v-card-text class="pt-0 pb-0">
                        <v-container>
                            <v-row>
                                <v-col :cols="12">
                                    <v-text-field v-model="roleForm.name" label="Nombre" hide-details></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col :cols="12">
                                    <v-text-field v-model="roleForm.description" label="Descripción" hide-details></v-text-field>
                                </v-col>                                    
                            </v-row>                           
                        </v-container>
                    </v-card-text>
                </v-card>
                <br>
                <v-card class="padding-bootom-0">
                    <v-card-title class="pt-2 pb-2">
                        Permisos
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text class="card-permissions pt-0 pb-0">
                        <v-col cols="12">
                            <v-treeview
                                selectable
                                selected-color="blue"
                                :items="permissions"
                                open-on-click
                                v-model="roleForm.selected"
                            ></v-treeview>
                        </v-col>
                    </v-card-text>
                </v-card>
                <br>
                <v-divider></v-divider>
                <br>
                <div class="text-a-right">
                    <v-btn color="error" outlined @click="closeForm()" class="wost-btn-new">Cancelar</v-btn>
                    &nbsp;
                    <v-btn v-if="actionCrud === 'create'" color="primary" raised @click="addRole()" class="wost-btn-new">Guardar</v-btn>
                    <v-btn v-else color="primary" raised @click="modifyRole()" class="wost-btn-new">Actualizar</v-btn>
                </div>                
            </v-form>
        </div>
    </v-navigation-drawer>
    
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';

import {APIService} from '@/APIService';
const apiService = new APIService();

export default {
    name: 'CreateOrUpdate',
    computed: {
        ...mapState('roles', [
            'roles',
            'role',
            'roleId',
            'resources',
            'newRole',
            'permissions'
        ]),
    },
    data() {
        return {
            titleForm: '',
            drawer: false,
            actionCrud: '',
            roleForm: {
                id: null,
                slug: null,
                name: null,
                description: null,
                selected: []
            }
        }
    },
    methods: {
        ...mapActions('roles', [
            'getRoles',
            'createRole',
            'updateRole',
            'getResources',
            'runSetNewRole'
        ]),
        ...mapMutations('roles', [
            'setRole',
            'setRoleId',
            'setResources',
            'setNewRole'
        ]),
        showForm(title, action) {
            this.clearform()
            this.titleForm = title
            this.actionCrud = action
            if (this.actionCrud === 'update') {
                this.setRoleId(this.role.id)
                this.setRoleForm(this.role)
            }
            this.drawer = !this.drawer
        },
        clearform() {
            this.roleForm.id = null
            this.roleForm.name = null
            this.roleForm.description = null
            this.roleForm.selected = []
        },
        setRoleForm(role) {
            this.roleForm.id = role.id
            this.roleForm.name = role.name
            this.roleForm.description = role.description
            this.roleForm.selected = role.selected
        },
        closeForm() {
            this.drawer = false
        },
        addRole() {
            this.runSetNewRole(this.roleForm)
            this.createRole()
            this.closeForm()
        },
        modifyRole() {
             this.setRole(null)
             this.setRole(this.roleForm)
             this.updateRole()
             this.closeForm()
        }
    },
    mounted() {
        this.getResources()
    }
}
</script>

<style>
.card-permissions{
    height: 48vh;
    overflow-y: auto;
}

.v-treeview-node__root{
    min-height: 25px !important;
}
</style>